function keepInfoOnFormError(e){
    const formData = new FormData(e.target);
    
    const lastName = formData.get('customer[last_name]');
    const firstName = formData.get('customer[first_name]');
    const email = formData.get('customer[email]');
    const password = formData.get('customer[password]');
    const storage = firstName + ";" + lastName + ";" + email + ";" + password;

    window.localStorage.setItem('custom_create_account',storage);
}

